import { slaChip, humanOverdue } from "@/lib/constants";

export default function SLABadge({ status, remaining }) {
  const { cls, label } = slaChip(status);
  const suffix = status === "overdue" ? ` · ${humanOverdue(Math.abs(remaining || 0))}` : (
    status === "due_soon" && remaining != null ? ` · ${remaining}d left` : ""
  );
  return (
    <span className={cls} data-testid={`sla-${status}`}>
      <span className="dot" />{label}{suffix}
    </span>
  );
}
